import { Box, FormControl, MenuItem, TextField } from '@material-ui/core';
import Check from '@material-ui/icons/Check';
import React, { ChangeEvent, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
	SearchSortValue,
	AppState,
	AppThunkDispatch,
	SearchSortAction,
	searchChangeSortOrder,
	httpGet,
	HttpAction
} from '../../../redux';
import { Body1 } from '../../atoms';

import './search-result-sort.styles.scss';

export interface ISearchResultSortStateProps {
	sortValue: SearchSortValue;
	changeSortOrder: (sortValue: SearchSortValue) => void;
	triggerSearchLoading: () => void;
}

function SearchResultSortView(
	props: ISearchResultSortStateProps
): ReactElement {
	const { sortValue, changeSortOrder, triggerSearchLoading } = props;
	const { t } = useTranslation('general');

	function handleSortChange(
		event: ChangeEvent<{
			name?: string | undefined;
			value: unknown;
		}>
	): void {
		const value: SearchSortValue = event.target.value as SearchSortValue;
		triggerSearchLoading();
		changeSortOrder(value);
	}

	function ActiveCheckmark({ value }: { value: string }): ReactElement {
		if (sortValue !== value) return <></>;

		return <Check className="sort-select-checkmark" />;
	}

	return (
		<Box className="search-result-sort">
			<Body1>{t('sort.sortTitle')}</Body1>
			<FormControl
				variant="outlined"
				className="search-result-sort-dropdown"
			>
				<TextField
					select
					onChange={handleSortChange}
					value={sortValue}
					name="sort-select"
					variant="outlined"
					SelectProps={{
						MenuProps: {
							anchorOrigin: {
								vertical: 'bottom',
								horizontal: 'left'
							},
							transformOrigin: {
								vertical: 'top',
								horizontal: 'left'
							},
							getContentAnchorEl: null
						}
					}}
				>
					<MenuItem value="mapNumber">
						<ActiveCheckmark value="mapNumber" />{' '}
						{t('sort.mapNumber')}
					</MenuItem>
					<MenuItem value="ascending">
						<ActiveCheckmark value="ascending" />
						{t('sort.alfabeticAscending')}
					</MenuItem>
					<MenuItem value="descending">
						<ActiveCheckmark value="descending" />
						{t('sort.alfabeticDescending')}
					</MenuItem>
				</TextField>
			</FormControl>
		</Box>
	);
}

function mapStateToProps(state: AppState) {
	return {
		sortValue: state.search.sortOrder
	};
}

function mapDispatchToState(
	dispatch: AppThunkDispatch<SearchSortAction | HttpAction>
) {
	return {
		changeSortOrder: (sortValue: SearchSortValue) =>
			dispatch(searchChangeSortOrder(sortValue)),
		triggerSearchLoading: () => dispatch(httpGet('search'))
	};
}

export const SearchResultSort = connect(
	mapStateToProps,
	mapDispatchToState
)(SearchResultSortView);
